import React from "react";
import BottomNav from "../../Components/BottomNav";
import NavBar from "../../Components/interface/NavBar";
import NavBar2 from "./NavBar";
import styles from "./History.module.css";
import { Outlet } from "react-router";

function History(props) {
  return (
    <section>
      <NavBar title="History" setShowMenu={props.setShowMenu} />
      <div className={styles.head}>
        <div className={styles.main_hero}>
          <NavBar2 />
          <Outlet />
        </div>
      </div>
      <BottomNav />
    </section>
  );
}

export default History;
